module.exports = __webpack_public_path__ + "media/Alert 1.5a0df281.mp3";